module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_loom_2.5607e73a.jpg";